<template>
  <!-- 年假延期 -->
  <div class="detail">
    <ax-panel title="基本信息">
      <van-cell
        title="申请延期类型"
        :value="data.header.qh_ann_defer_type_description"
      ></van-cell>
      <van-cell
        title="可延年假天数"
        :value="data.header.qh_ann_days"
      ></van-cell>
      <van-cell
        title="可延迟日期"
        :value="data.header.qh_defer_date"
      ></van-cell>
      <van-cell title="申请说明" :value="data.header.comments"></van-cell>
      <van-cell
        title="附件"
        v-if="data.qh_abs_011_atta && data.qh_abs_011_atta.length > 0"
      >
        <template v-for="item in data.qh_abs_011_atta">
          <div class="ax-down-box" @click="getFileData(item.attachsysfilename)">
            <div v-if="item.filename" class="item_content_name">
              <div class="label_box blue">{{ item.filename }}</div>
            </div>
            <span class="item_content_val"
              ><van-icon class-prefix="iconfont" name="down" />
            </span>
          </div>
        </template>
      </van-cell>
    </ax-panel>
    <ax-panel title="申请人信息">
      <van-cell title="姓名" :value="data.header.emplid_description"></van-cell>
      <!-- <van-cell title="邮箱">
        <a class="mail_a" :href="'mailto:'+data.header.email_addr">{{data.header.email_addr}}</a>
      </van-cell> -->
      <van-cell title="电话">
        <a class="link_a" :href="'tel:' + data.header.emplid_phone">{{
          data.header.emplid_phone
        }}</a>
      </van-cell>
      <van-cell title="部门" :value="data.header.deptid_description"></van-cell>
    </ax-panel>
  </div>
</template>

<script>
export default {
  props: ["data"],
  data() {
    return {
      toast: null
    };
  },
  methods: {
    getFileData(attachsysfilename) {
      this.$router.push({
        name: "fileImg",
        query: {
          ...this.$route.query,
          ...{
            emplid: this.data.header.emplid, // 员工编号
            action_dt_ss: this.data.header.action_dt_ss, // 提交时间
            effseq: this.data.header.effseq, // 生效序号
            attachsysfilename: attachsysfilename, // 系统唯一文件名称
            title: "年假延期",
            path: "annualLeaveExtension"
          }
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.ax-down-box {
  line-height: 22px;
  height: 22px;
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  font-size: 14px;
  color: #999;
  &:not(:first-child) {
    line-height: 32px;
    height: 32px;
  }
  .item_content_name {
    -webkit-box-flex: 1;
    -webkit-flex: 1 1 0%;
    flex: 1 1 0%;
    max-width: 200px;
    .label_box {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      &.blue {
        color: #2fa5ff;
      }
    }
    .brief_box {
      font-size: 12px;
      line-height: 1.4;
    }
  }
  .item_content_val {
    min-height: 22px;
    display: -webkit-inline-box;
    display: -webkit-inline-flex;
    display: inline-flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
    -webkit-box-pack: end;
    -webkit-justify-content: flex-end;
    justify-content: flex-end;
    word-break: break-all;
    .iconfont {
      color: #ccc;
      font-size: 16px;
    }
  }
}
</style>
